







































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import InputNumber from "@/components/common/input/InputNumber.vue";
import InputCode from "@/components/common/input/InputCode.vue";
import { ElButton } from "element-ui/types/button";
import { Getter, Action } from "vuex-class";
import SaveDialog from "@/components/common/SaveDialog.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { MESSAGE } from "@/model/Message";
import ReservationDetailState from "@/store/reservation/state";
import { Utils } from "@/service/util";
import WorkAndBuhin from "@/components/WorkAndBuhin.vue";
import InspectValueDialog from "@/components/InspectValueDialog.vue";
import { InspectDescriptions } from "@/model/InspectGensha";
import { InspectValueItem } from "@/model/InspectItem";
import { InspectService } from "@/service/inspectService";
import { IppanSeibiService } from "@/service/IppanSeibiService";
import { CarSelectData } from "@/model/CarSelection";
import { InspectLineResult } from "@/model/InspectLineResult";
import { INSPECT_VALUE_VIEW_TYPE } from "@/model/InspectValueViewType";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import { WORK_AND_BUHIN_MODE, WorkAndBuhinMode } from "@/model/WorkAndBuhinData";
import * as InspectLinePageServiceModel from "@/model/InspectLinePageService"; // refactor : 現状はmodel式。serviceにはなっていない
import { InspectLinePageService } from "@/service/InspectLinePageService";

@Component({
  components: {
    InputNumber,
    InputCode,
    SaveDialog,
    ConfirmDialog,
    WorkAndBuhin,
    InspectValueDialog
  }
})
export default class InspectLine extends Vue {
  $refs!: {
    btnRigister: ElButton;
    errorDialog: ConfirmDialog;
    saveDialog: SaveDialog;
    cancelDialog: ConfirmDialog;
  };
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Action("setProgressState", { namespace: "SubHeader" })
  setProgressState: any;

  @Getter("currentState", { namespace: "ReservationDetail" })
  reservationState: ReservationDetailState;

  @Getter("currentState", { namespace: "CarSelection" })
  carSelection: CarSelectData;
  @Action("setState", { namespace: "CarSelection" })
  setStateCarSelection: any;

  @Action("setState", { namespace: "InspectLine" })
  setState: any;
  @Action("setSideSlip", { namespace: "InspectLine" })
  setSideSlip: any;

  @Getter("inspectLineList", { namespace: "InspectLine" })
  inspectLineListState: any;
  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  /** 2024-05-02 nextage [END] */

  pageService: InspectLinePageServiceModel.InspectLinePageService;
  service: InspectService;
  ippanSeibiService: IppanSeibiService;
  errorMsg: string = "";
  loadingText: string = MESSAGE.Loading;
  loading: boolean = true;

  headLightKbns: any = [];
  headLightLRKbns: any = [];
  headLightLuminanceKbns: any = [];
  activeInspect: any = {};
  displayValDialog: boolean = false;
  inspectData: InspectDescriptions[] = [];
  speedInspect: InspectDescriptions = {} as InspectDescriptions;
  dieselInspect: InspectDescriptions = {} as InspectDescriptions;
  hasDiesel: boolean = false;
  inspectLineList: InspectLineResult[] = [];
  hasData: boolean = false;
  headLightLuminance: number = 0;
  lightRightLuminance: number = 0;
  isSaving: boolean = false;
  tempSave: any = [];
  isWaitSaveSeibi: boolean = false;

  public utils: Utils = new Utils();

  get uketsuke() {
    if (this.reservationState) {
      return this.reservationState.uketsuke;
    }
    return {};
  }

  get makerCd() {
    if (this.uketsuke.srMakerCd) {
      return this.uketsuke.srMakerCd;
    }
    return "";
  }

  get modelCd() {
    if (this.uketsuke.srModelCd) {
      return this.uketsuke.srModelCd;
    }
    return "";
  }

  created() {
    this.$emit("onactivepage", this.$route.name);
    this.service = new InspectService();
    this.pageService = new InspectLinePageService();
    this.ippanSeibiService = new IppanSeibiService();
    this.init();
  }

  init() {
    this.pageService
      .getInspectLineResult(this.uketsukeExtendsId)
      .then(
        data => {
          this.loading = false;
          if (data) {
            const initialState = this.pageService.buildInitialResultState(
              data,
              this.inspectLineListState
            );
            this.hasData = initialState.hasData;
            this.inspectLineList = initialState.inspectLineList;
            this.headLightLuminance = initialState.headLightLuminance;
            this.lightRightLuminance = initialState.lightRightLuminance;

            if (initialState.syncItems.length > 0) {
              initialState.syncItems.forEach((item: InspectLineResult) => {
                this.save(item);
              });
            } else {
              this.setState(this.inspectLineList);
            }
          }
        },
        (error: any) => {
          console.log(error);
          this.onError(error);
          // this.inspectForm.sknUketsukeExtendsId = this.uketsukeExtendsId;
        }
      )
      .catch(error => {
        console.log(error);
        // this.inspectForm.sknUketsukeExtendsId = this.uketsukeExtendsId;
      });
    this.setBtnValue();
    this.pageService
      .getInspectLineSeibi(this.uketsukeExtendsId)
      .then((data: any) => {
        this.setInspectData(data);
      });

    if (this.carSelection.uketsukeCd) {
      this.checkDiesel();
    } else {
      this.pageService
        .getCarSelection(this.uketsukeExtendsId)
        .then((res: any) => {
          res.sknUketsukeExtendsId = this.uketsukeExtendsId;
          this.setStateCarSelection({ ...res, uketsukeCd: this.uketsukeCd });
          this.checkDiesel();
        });
    }
  }

  setInspectData(data: any) {
    if (data) {
      const seibiState = this.pageService.buildSeibiState(data);
      this.inspectData = seibiState.inspectData;
      if (seibiState.speedInspect) {
        this.$set(this, "speedInspect", seibiState.speedInspect);
      }
      if (seibiState.dieselInspect) {
        this.$set(this, "dieselInspect", seibiState.dieselInspect);
      }
    }
  }

  checkDiesel() {
    let hasDiesel = false;
    if (this.carSelection.fuelKbn == 2) {
      hasDiesel = true;
    }
    this.$set(this, "hasDiesel", hasDiesel);
  }

  setBtnValue() {
    this.pageService
      .getKbnSkns("skn_inspect_line_head_light")
      .then(
        data => {
          this.headLightKbns = data;
        },
        (error: any) => {
          console.log(error);
        }
      )
      .catch(error => {
        console.log(error);
      });

    this.pageService
      .getKbnSkns("skn_inspect_line_head_light_koudo")
      .then(
        data => {
          this.headLightLuminanceKbns = data;
        },
        (error: any) => {
          console.log(error);
        }
      )
      .catch(error => {
        console.log(error);
      });

    this.pageService
      .getKbnSkns("skn_inspect_line_head_light_result")
      .then(
        data => {
          this.headLightLRKbns = data;
        },
        (error: any) => {
          console.log(error);
        }
      )
      .catch(error => {
        console.log(error);
      });
  }

  // setForm(props: string, valueProp?: string) {
  //   let value = this.inspectForm[props] == 1 ? 0 : 1;
  //   this.$set(this.inspectForm, props, value);
  //   if (valueProp && value == 1) {
  //     this.$set(this.inspectForm, valueProp, null);
  //   }
  // }

  save(item: InspectLineResult) {
    if (this.isSaving) {
      this.tempSave.push(this.utils.deepCopy(item));
    } else {
      this.isSaving = true;
      this.pageService.saveInspectLineResult(item).then(
        (res: any) => {
          this.setState(this.inspectLineList);
          this.isSaving = false;
          if (res && item.inspectResult == InspectButtonValue.CROSS) {
            setTimeout(() => {
              this.$emit("getnav");
            }, 500);
          }
          this.saveTempSaving();
        },
        error => {
          this.handleError(error);
        }
      );
    }
  }

  saveTempSaving() {
    if (this.tempSave.length > 0) {
      const obj = this.tempSave.pop();
      this.save(obj);
    }
    if (this.isWaitSaveSeibi) {
      this.isWaitSaveSeibi = false;
      this.saveSeibi();
    }
  }

  saveSeibi() {
    if (this.isSaving) {
      this.isWaitSaveSeibi = true;
    } else {
      this.applyInspectLineSeibiSyncState(
        this.speedInspect,
        this.pageService.buildSeibiSyncApplyState(this.speedInspect, this.inspectLineList[4])
      );
      this.applyInspectLineSeibiSyncState(
        this.dieselInspect,
        this.pageService.buildSeibiSyncApplyState(this.dieselInspect, this.inspectLineList[11])
      );
      this.isSaving = true;
      // sendSocket:ソケット仮04
      // sendSocket:ソケット仮06
      this.pageService.saveInspectLineSeibi(this.inspectData).then(
        (res: any) => {
          this.isSaving = false;
          this.saveTempSaving();
          if (res.status == 200 && res.body && res.body) {
            this.setInspectData(res.body);
          }
        },
        error => {
          this.handleError(error);
        }
      );
    }
  }

  saveResultAndSeibi(item: InspectLineResult) {
    this.save(item);
    this.saveSeibi();
  }

  applyInspectLineSeibiSyncState(
    inspect: InspectDescriptions,
    syncState: InspectLinePageServiceModel.InspectLineSeibiSyncApplyState
  ) {
    if (!syncState.shouldApply) {
      return;
    }
    inspect.inspectResult = syncState.inspectResult as number;
    inspect.workBuhinSelected = syncState.workBuhinSelected as number;
  }

  onError(res: any) {
    this.loading = false;
    this.errorMsg = this.utils.getHttpErrorMessage(res);
    this.$refs.errorDialog.onOpen();
  }

  onSave() {
    this.$emit("saveSpentTime");
    this.$refs.saveDialog.onOpen();
  }

  onRegister() {
    this.$emit("saveSpentTime");
    this.$emit("onregister", { pageName: this.$route.name });
  }

  // Validation
  get isRequired() {
    try {
      if (!this.hasSideSlip) {
        return true;
      }
      if (!this.hasSpeedMeter) {
        return true;
      }
      for (let i = 1; i < 11; i++) {
        if (!this.hasResult(this.inspectLineList[i])) {
          return true;
        }
      }
      if (this.hasDiesel && !this.hasDieselResult) {
        return true;
      }
    } catch (ex) {
      console.log(ex);
    }

    return false;
  }

  get hasSideSlip() {
    const item = this.inspectLineList[0];
    if (item) {
      if (item.inOut && item.inspectResult) {
        return true;
      }
    }
    return false;
  }

  get hasSpeedMeter() {
    return this.pageService.hasSpeedMeterCompleted(
      this.speedInspect,
      this.inspectLineList[4]
    );
  }

  hasResult(item: InspectLineResult) {
    return this.pageService.hasResult(item);
  }

  onEnterlightRightLuminance(e: any) {
    setTimeout(() => {
      if (e.target) {
        e.target.blur();
      }
    }, 100);
  }

  showWork(inspectType: InspectLinePageServiceModel.InspectLineWorkType) {
    const activeInspect = this.pageService.buildWorkBuhinData(inspectType, {
      speedInspect: this.speedInspect,
      dieselInspect: this.dieselInspect
    });
    if (activeInspect && Object.keys(activeInspect).length > 0) {
      this.activeInspect = activeInspect;
    }
  }

  onConfirmBuhin(data: { inspectItem: any; seibi: any; notManual: boolean }) {
    this.applyInspectLineConfirmState(
      this.pageService.buildConfirmApplyState(this.activeInspect, {
        speedInspect: this.speedInspect,
        dieselInspect: this.dieselInspect
      })
    );
    this.saveSeibi();
  }

  applyInspectLineConfirmState(
    confirmState: InspectLinePageServiceModel.InspectLineConfirmApplyState
  ) {
    this.$set(
      confirmState.inspect,
      "workBuhinSelected",
      confirmState.workBuhinSelected
    );
  }

  onCloseBuhin() {
    this.$set(this, "activeInspect", {});
  }

  openValueDialog() {
    this.activeInspect = this.utils.deepCopy(this.speedInspect);
    this.activeInspect.showValue = true;
  }

  onConfirmValue(inspectValueList: InspectValueItem[]) {
    let speedMeter: number | undefined;
    if (inspectValueList && inspectValueList.length > 0) {
      speedMeter = this.service.getInspectResultByInspectValue(
          this.speedInspect.inspectValueViewType,
          inspectValueList
      );
    }
    this.applyInspectLineValueConfirmState(
      this.pageService.buildValueConfirmApplyState(inspectValueList, speedMeter)
    );
    this.saveResultAndSeibi(this.inspectLineList[4]);
  }

  applyInspectLineValueConfirmState(
    valueState: InspectLinePageServiceModel.InspectLineValueConfirmApplyState
  ) {
    if (!valueState.shouldApply) {
      return;
    }
    this.speedInspect.inspectValueList = valueState.inspectValueList as InspectValueItem[];
    this.inspectLineList[4].inspectValue = valueState.inspectValue;
    this.inspectLineList[4].inspectResult = valueState.inspectResult as number;
    this.speedInspect.inspectResult = valueState.inspectResult as number;
  }

  onCloseValue() {
    this.activeInspect.showValue = false;
    this.activeInspect = {};
  }

  hasSpeedValue() {
    return this.pageService.hasSpeedValue(this.speedInspect);
  }

  buttonLabel(inspect: InspectDescriptions) {
    return this.pageService.getWorkButtonLabel(inspect);
  }

  onSideSlipChange(val: number | null) {
    if (val == null) {
      val = 0;
    }
    const result = this.service.getInspectResultByInspectValue(
      INSPECT_VALUE_VIEW_TYPE.SIDE_SLIP,
      [{ inspectValue: val }]
    );
    this.inspectLineList[0].inspectResult = result;
    this.inspectLineList[0].inspectValue = val;
    this.setSideSlip(val);
    this.save(this.inspectLineList[0]);
  }

  onSetChousei(val: number, item: InspectLineResult) {
    if (val == 2) {
      item.isChousei = 1;
    } else {
      item.isChousei = 0;
    }
    this.save(item);
  }

  onChangeKbn(val: number, item: InspectLineResult) {
    if (val == 1) {
      item.inspectResult = 1;
      item.isMigaki = 0;
      item.isKoukan = 0;
    } else {
      item.inspectResult = 2;
      if (val == 2) {
        item.isMigaki = 1;
        item.isKoukan = 0;
      } else {
        item.isMigaki = 0;
        item.isKoukan = 1;
      }
    }
    this.save(item);
  }

  get hasDieselResult() {
    return this.pageService.hasDieselCompleted(
      this.dieselInspect,
      this.inspectLineList[11]
    );
  }

  handleError(error: any) {
    this.isSaving = false;
    let errorMsg = this.utils.getHttpErrorMessage(error);
    this.$message({
      message: errorMsg,
      type: "error"
    });
    this.init();
  }

  beforeDestroy() {
    this.saveTempSaving();
  }

  onCancel() {
    if (this.$refs.cancelDialog) {
      this.$refs.cancelDialog.onOpen();
    }
  }

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.pageService.saveCancel(data).then((res: any) => { // sendSocket:32車検中止
      this.$router.push({ name: "reservation" });
    });
  }

  gotoFactoryCustomer() {
    this.pageService.getReservationTarget(this.uketsukeExtendsId)
    .then((res: any) => {
      if (res.length > 0) {

        res.forEach((e: any, i: number) => {
          if ( e.uketsukeCd == e.uketsukeParentCd || e.uketsukeParentCd == "") {
            this.$router.push({
              name: "customer",
              params: { code: e.uketsukeCd }
            });
          }
        });
        
      }
    });
  }

  get workAndBuhinMode(): WorkAndBuhinMode {
    return WORK_AND_BUHIN_MODE.INSPECT_LINE;
  }
}
